import { IcContact16Icon } from '@gem/icons';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

const Contact = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      Icon={IcContact16Icon}
      title={title}
      text={message.payload.typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};

export default Contact;
